import $ from 'jquery';
import slick from 'slick-carousel';
import modaal from 'modaal';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Testimonial {
    constructor(target, settings) {

    }

    init() {
        this.testimonialSlider();
        this.handleTestimonialVideoButton();
    }

    handleTestimonialVideoButton() {
        $('.testimonial-video').on('click', (e) => {
            const btn = $(e.currentTarget);
            let videoUrl = btn.attr('data-video');
            const testimonialContainer = btn.closest('.testimonial');
            const modal = testimonialContainer.find('.testimonial_modal');

            if (videoUrl) {
                $('#testimonial_modal iframe').attr('src', videoUrl);
            }

            $(e.currentTarget).modaal({
                content_source: modal,
                overlay_opacity: 0.6,
                custom_class: 'testimonial-video-modal',
                width: 750,
                start_open: true,
                before_open: () => {
                    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                    document.body.style.overflow = 'hidden';
                    document.body.style.paddingRight = `${scrollbarWidth}px`;
                },
                after_close: () => {
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';
                }
            });
        });
    }

    testimonialSlider() {
        let $slickElement = $('.testimonial-list');

        if ($slickElement.length > 0) {
            let $testimonialListClasses = $slickElement.closest('section').attr('class').trim();
            if (!$testimonialListClasses) {
                $slickElement.addClass('no-background');
            }            

            $slickElement.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
                if (currentSlide === undefined) {
                    currentSlide = 0;
                }

                $('.js-count').text(`${currentSlide + 1} of ${slick.slideCount}`);
            });
            
            if (!$('.testimonial-list').length) return;

            if ($slickElement.parent().hasClass('alt-style')) {
                $('.testimonial-list').slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    adaptiveHeight: false,
                    centerMode: true,
                    variableWidth: true,
                    prevArrow: $('.slick-prev.custom-arrow'),
                    nextArrow: $('.slick-next.custom-arrow')
                });
            } else {
                $('.testimonial-list').slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    adaptiveHeight: false                    
                });
            }
        }
    }
}

export default Testimonial;

$(() => {
	const testimonial = new Testimonial();
	testimonial.init();
});